import { SM_THEME as T } from './stateMachineTheme'
import { nodeControlClass } from '../../lib/nodeControlClass.js'
import { InputPins, OutputPins } from './smPins'
import { selectedBorder } from './selectedBorder.js'

export function StateNode({ data, selected }) {
  const isActive    = data.isActive ?? false
  const animRatio   = data._debugAnimRatio
  const hasAnimRatio = isActive && animRatio !== null && animRatio !== undefined

  return (
    <div
      onDoubleClick={e => { e.stopPropagation(); data.onDrillIn?.() }}
      style={{
        background: isActive ? T.nodeBgActive : selected ? T.nodeBgSelected : T.nodeBg,
        border: `2px solid ${isActive ? T.nodeBorderActive : selected ? selectedBorder(T.nodeBorder) : T.nodeBorder}`,
        borderRadius: 6,
        padding: '10px 14px',
        minWidth: 140,
        color: '#ddd',
        fontFamily: 'var(--m-font)',
        fontSize: 12,
        boxShadow: isActive ? T.nodeGlowActive : 'none',
        cursor: 'default',
        userSelect: 'none',
      }}
    >
      {/* Status label */}
      <div style={{
        color: isActive ? T.labelActive : T.labelState,
        fontWeight: 'bold',
        fontSize: 9,
        letterSpacing: 1,
        marginBottom: 5,
      }}>
        {isActive ? '▶ ACTIVE' : 'STATE'}
      </div>

      {/* Name input */}
      <input
        className={nodeControlClass()}
        value={data.name ?? 'New State'}
        onChange={e => data.onChange?.('name', e.target.value)}
        onMouseDown={e => e.stopPropagation()}
        // Double-click selects the name here (fieldDoubleClick.js); it must not drill into the state.
        onDoubleClick={e => e.stopPropagation()}
        placeholder="State name"
        style={{
          background: 'transparent',
          border: 'none',
          borderBottom: `1px solid ${isActive ? T.nodeBorderActive : T.nodeBorder}`,
          color: T.title,
          fontSize: 13,
          fontWeight: 'bold',
          fontFamily: 'var(--m-font)',
          width: '100%',
          outline: 'none',
          marginBottom: 4,
          padding: '2px 0',
        }}
      />

      {/* Double-click hint */}
      <div style={{ color: T.hint, fontSize: 9, fontStyle: 'italic' }}>
        double-click to edit
      </div>

      {/* Animation progress bar */}
      {hasAnimRatio && (
        <div style={{ marginTop: 6, height: 3, background: T.progressTrack, borderRadius: 2, overflow: 'hidden' }}>
          <div style={{
            width: `${animRatio * 100}%`,
            height: '100%',
            background: T.progressFill,
            transition: 'width 0.1s linear',
          }} />
        </div>
      )}

      {/* ENG-1072: inputs top/bottom, outputs at the bottom corners. A
          transition picks a side per render from node geometry. */}
      <InputPins />
      <OutputPins />
    </div>
  )
}
